import { AddressCell } from '@/components/ui'
import { InsightConfigurationType, Alarm, LatLng } from '@/types/dashboard-types'

import { duration, interval } from './formatUtils'

import { getSeverityLabel } from '../components/SeverityDropdown'

const typeMap = {
  raised: { field: 'raisedLocation', title: 'Raised', address: 'address' },
  cleared: { field: 'clearedLocation', title: 'Cleared', address: 'address' },
  raisedGeofence: { field: 'raisedGeofence', title: 'Raised Geofence', address: 'name' },
}

const AlarmLocationDrilldown = (
  alarm: Alarm,
  configuration: InsightConfigurationType,
  type: 'raised' | 'cleared' | 'raisedGeofence',
  companyId?: number,
  fallback = 'N/A'
) => {
  const t = typeMap[type]
  const loc = alarm[t.field as keyof Alarm] as LatLng
  if (!loc) {
    return fallback
  }
  const address = loc[t.address as keyof typeof loc]
  if (!address) {
    return fallback
  }
  if (!loc?.latitude && !loc?.longitude) {
    return address
  }

  return {
    id: `${type}-${alarm.id}`,
    address,
    lat: loc.latitude,
    lng: loc.longitude,
    companyId: alarm.company.id || companyId,
    title: `${configuration.title}: ${alarm.asset.name} (${t.title} Location)`,
    markerContent: (
      <div>
        <div>Asset: {alarm.asset.name}</div>
        <div>Alarm: {alarm.alarmCode.description}</div>
        <div>Severity: {getSeverityLabel(String(alarm.alarmCode.severityCode))}</div>
        <div>Raised: {alarm.raisedTime.toLocaleString()}</div>
        <div>Cleared: {alarm.clearedTime ? alarm.clearedTime.toLocaleString() : 'Active'}</div>
        <div>
          Duration: {alarm.clearedTime ? interval(alarm.raisedTime, alarm.clearedTime) : duration(alarm.raisedTime)}
        </div>
      </div>
    ),
  } as AddressCell
}

export default AlarmLocationDrilldown
